function processDetails(stockOrderOut) {
    if (stockOrderOut.stock_order_details) {
        var sum_order_num = 0;
        var sum_confirm_num = 0;
        var sum_out_num = 0;
        var sum_number = 0;
        var out_num_sum = 0;
        var order_num_sum = 0;
        var num_sum = 0;
        var category_code = '';
        var stockOrderDetails = []
        stockOrderOut.stock_order_details.forEach((detail) => {
            if (stockOrderOut.status == 1) {
                detail.number = detail.order_num;
            } else if (stockOrderOut.status == 2) {
                detail.number = detail.confirm_num;
            } else if (stockOrderOut.status == 3) {
                detail.number = detail.out_num;
            }
            sum_order_num += detail.order_num;
            sum_confirm_num += detail.confirm_num;
            sum_out_num += detail.out_num;
            sum_number += detail.number;
            if(category_code != detail.category_code) {
                category_code = detail.category_code;
                out_num_sum = detail.out_num;
                order_num_sum = detail.order_num
                num_sum = detail.number
            } else {
                out_num_sum += detail.out_num;
                order_num_sum += detail.order_num;
                num_sum  +=detail.number
            }
            detail.out_num_sum = out_num_sum
            detail.order_num_sum = order_num_sum
            detail.num_sum = num_sum
            stockOrderDetails.push(detail)
            
        });
        stockOrderOut.sum_order_num = sum_order_num;
        stockOrderOut.sum_confirm_num = sum_confirm_num;
        stockOrderOut.sum_out_num = sum_out_num;
        stockOrderOut.sum_number = sum_number;
        stockOrderOut.stock_order_details = stockOrderDetails
    }
    return stockOrderOut;
}

export default {
    processDetails
};